(function ($) {
  'use strict';

  /**
   * Nav Tray Controls
   */

  $.fn.menuTrayControls = function (args) {
    args = $.extend({
      target_el_ID: '',
      class_animate_in: 'is-animate-in--from-start',
      class_animate_out: 'is-animate-out--from-start',
      mobile_breakpoint: 760,
    }, args );
    var $button_control = $(this);
    var $site_wrap = $('body');
    var target_el_ID = args.target_el_ID;
    var class_animate_in = args.class_animate_in;
    var class_animate_out = args.class_animate_out;
    var mobile_breakpoint = args.mobile_breakpoint;

    if ( ! target_el_ID ) {
      target_el_ID = $button_control.attr('aria-controls');
    }

    var $menu_tray = $( '#' + target_el_ID );

    // Get all matching tray controls
    var $tray_controls = $( '[aria-controls="' + target_el_ID + '"]' );

    // Get interactable els for focus toggle
    var $menu_tray_links = $menu_tray
      .find('a[href], button, input, select, textarea')
      .not('[disabled]');
    var $mobile_header_links = $('.site-header--mobile')
      .find('a[href], button, input, select, textarea')
      .not('[disabled]');
    var $mobile_tab_links = $menu_tray_links.add( $mobile_header_links );

    /**
     * Nav Tray Controls
     * ---
     */

    // Disable button during animations
    // *a11y - Not using `disabled` attr, so buttons retain focus
    var is_button_disabled = false;

    $tray_controls.on('click', function () {
      if ( is_button_disabled ) {
        return false;
      }
      is_button_disabled = true;

      toggleNavTray();

      is_button_disabled = false;
    });

    // Close on esc keypress
    $(document).on('keydown', function (e) {
      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( e.key === 'Escape'
        && is_tray_expanded ) {
        closeNavTray();
      }
    });

    // Close if window is resized above `mobile_breakpoint`
    $(window).on('resize', function () {
      if ( ! mobile_breakpoint ) {
        return false;
      }

      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( $(window).width() > mobile_breakpoint
        && is_tray_expanded ) {
        closeNavTray();
      }
    });


    /**
     * Toggle / Open / Close
     */

    // Toggle Nav Tray
    function toggleNavTray() {
      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( is_tray_expanded ) {
        closeNavTray();
      } else {
        openNavTray();
      }
    }

    // Expand tray
    function openNavTray() {

      // Update aria attrs
      $tray_controls.attr( 'aria-expanded', 'true' );
      $menu_tray.attr( 'aria-hidden', 'false' );

      // Lock site scroll
      $site_wrap.css( 'overflow', 'hidden' );

      // Slide Tray
      $menu_tray
        .removeClass( class_animate_out )
        .addClass( class_animate_in );

      // Enable tabs
      $menu_tray.prop( 'inert', false );

      // Lock tabbing to focusable els inside tray + main menu
      lock_tab_focus( $mobile_tab_links );
    }

    // Collapse tray
    function closeNavTray() {
      // Update aria attrs
      $tray_controls.attr( 'aria-expanded', 'false' );
      $menu_tray.attr( 'aria-hidden', 'true' );

      // Slide Tray
      $menu_tray
        .removeClass( class_animate_in )
        .addClass( class_animate_out );

      // Unlock site scroll
      $site_wrap.css( 'overflow', 'auto' );

      // Unlock tabbing
      $menu_tray.prop( 'inert', true );
      unlock_tab_focus( $mobile_tab_links );

      // Focus back to header toggle button
      $button_control.focus();
    }


    /**
     * Tab Locks
     */

    // Enable Tab Lock
    function lock_tab_focus( $links ) {
      // Get tab els
      // - Currently visible and not disabled
      // - Visible may change as sub-menus open and close
      var $focusable_inputs = $links
        .not( '[disabled]' )
        .filter( ':visible' );

      // Get first and last elements
      var $first_input = $focusable_inputs.first();
      var $last_input = $focusable_inputs.last();

      // First El
      // - Loop "Shift + Tab" to last focusable element
      $first_input.on('keydown.tablock', function (e) {
        if ( e.key === 'Tab' && e.shiftKey ) {
          $last_input.focus();
          return false;
        }
      });

      // Last El
      // - Loop "Tab" to first focusable element
      $last_input.on('keydown.tablock', function (e) {
        if ( e.key === 'Tab' && ! e.shiftKey ) {
          $first_input.focus();
          return false;
        }
      });
    }

    // Disable Tab Lock
    function unlock_tab_focus( $links ) {
      $links.off( '.tablock' );
    }

    return this;
  };

})(jQuery);
